const triggerHookFormFieldValidation = async (trigger, fields) => {
  await Promise.all(fields.map(field => trigger(field)));
};

export default triggerHookFormFieldValidation;
